import { types, flow } from 'mobx-state-tree';
import API from '../../api/parking';
import requsetErrorMessage from '../../helpers/requsetErrorMessage';
import ParkingPass from './ParkingPass';

const ParkingPasses = types
    .model('ParkingPasses', {
        passes: types.array(ParkingPass),
        error: types.union(
            types.optional(types.string, ''),
            types.optional(types.array(types.string), []),
        ),
        dataLoaded: types.optional(types.boolean, false),
    })
    .actions((self) => ({
        getPasses: flow(function* getPasses(parkingFieldId, seasonId) {
            self.error = '';
            try {
                const params = {};
                if (parkingFieldId) params.parking_field_id = parkingFieldId;
                if (seasonId) params.season_id = seasonId;
                const res = yield API.getPasses({ params });
                self.passes = res.data;
                self.dataLoaded = true;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        createPass: flow(function* createPass(data) {
            try {
                yield API.createPass(data);
            } catch (error) {
                throw error;
            }
        }),
        createBulk: flow(function* createBulk(data) {
            try {
                yield API.createBulk(data);
            } catch (error) {
                throw error;
            }
        }),
        importCsv: flow(function* importCsv(data) {
            try {
                yield API.importCsv(data);
            } catch (error) {
                throw error;
            }
        }),
        importPasses: flow(function* importPasses(data) {
            try {
                yield API.importPasses(data);
            } catch (error) {
                throw error;
            }
        }),
        setDataLoaded() {
            self.dataLoaded = true;
        },
    }));

export default ParkingPasses;
